var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14238_5799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50105 6.1938V8.59579M7.50105 10.9978H7.50705M6.66955 3.1263L1.73053 11.6573C1.45658 12.1305 1.31961 12.3671 1.33985 12.5613C1.35751 12.7307 1.44624 12.8846 1.58397 12.9847C1.74188 13.0995 2.01526 13.0995 2.56203 13.0995H12.4401C12.9868 13.0995 13.2602 13.0995 13.4181 12.9847C13.5559 12.8846 13.6446 12.7307 13.6622 12.5613C13.6825 12.3671 13.5455 12.1305 13.2716 11.6573L8.33255 3.12629C8.05958 2.65481 7.9231 2.41906 7.74503 2.33988C7.58971 2.27082 7.41239 2.27082 7.25707 2.33988C7.079 2.41906 6.94252 2.65481 6.66955 3.1263Z",
    stroke: "white",
    strokeWidth: 1.20099,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14238_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4119,
    height: 14.4119,
    fill: "white",
    transform: "translate(0.294922 0.789062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.a7cb9e0c8d0c30ad292e9f80ff5abe26.svg";
export { ForwardRef as ReactComponent };